module.exports = __webpack_public_path__ + "img/myguard_about_06.bcfe3c14.png";